import { WIDGET_GET_YOUR_KITS, WIDGET_GET_YOUR_KITS_RESULT, WIDGET_GET_YOUR_KITS_ERROR } from './constants';

export const widgetYourKitsReducer = (state = {}, action) => {
  switch (action.type) {
    case WIDGET_GET_YOUR_KITS:
      return {
        ...state,
        isLoading: true,
        isError: false,
        kits: [],
      };
    case WIDGET_GET_YOUR_KITS_RESULT:
      return {
        ...state,
        isLoading: false,
        isError: false,
        kits: action.response,
      };

    case WIDGET_GET_YOUR_KITS_ERROR: {
      return {
        ...state,
        isLoading: false,
        isError: true,
        kits: [],
      };
    }
    default:
      return state;
  }
};
